import * as React from 'react';
import { Nullable } from '../../../utils/types';

interface FilespaceCardTopRowProperties {
    filespaceId: string;
    filespaceName: string;
    text: string;
    icon: Nullable<JSX.Element>;
    isDeleteDisabled: boolean;
    isRenameDisabled: boolean;
}

class FilespaceCardTopRow extends React.Component<FilespaceCardTopRowProperties> {
    constructor(props: FilespaceCardTopRowProperties) {
        super(props);
    }

    render() {
        const menuHasButtons = !this.props.isRenameDisabled || !this.props.isDeleteDisabled;
        return (
            <React.Fragment>
                <span className="card-label">
                    <StreamingSupportIcon icon={this.props.icon} />
                    {this.props.text}
                </span>

                {menuHasButtons && (
                    <ul className="nav nav-pills">
                        <li className="nav-item dropdown">
                            <ThreeDotsButton />
                            <div className="dropdown-menu dropdown-menu-right">
                                <button className="ttip dropdown-item" data-toggle="modal" data-target="#filespaceDetailsModal">
                                    Details
                                </button>

                                {!this.props.isRenameDisabled && (
                                    <button className="ttip dropdown-item" data-toggle="modal" data-target="#renameFilespaceModal">
                                        Rename
                                    </button>
                                )}

                                {!this.props.isDeleteDisabled && (
                                    <button className="ttip dropdown-item red" data-toggle="modal" data-target="#deleteModal">
                                        Delete
                                    </button>
                                )}
                            </div>
                        </li>
                    </ul>
                )}
            </React.Fragment>
        );
    }
}

function ThreeDotsButton() {
    return (
        <a
            className="nav-link dropdown-toggle btn-sm"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <svg width="4px" height="14px" viewBox="0 0 4 14" version="1.1">
                <path d="M1.68,10 C2.1333356,10 2.526665,10.166665 2.86,10.5 C3.193335,10.833335 3.36,11.2266644 3.36,11.68 C3.36,12.1333356 3.193335,12.526665 2.86,12.86 C2.526665,13.193335 2.1333356,13.36 1.68,13.36 C1.2266644,13.36 0.833335,13.193335 0.5,12.86 C0.166665,12.526665 0,12.1333356 0,11.68 C0,11.2266644 0.166665,10.833335 0.5,10.5 C0.833335,10.166665 1.2266644,10 1.68,10 Z M1.68,5 C2.1333356,5 2.526665,5.166665 2.86,5.5 C3.193335,5.833335 3.36,6.2266644 3.36,6.68 C3.36,7.1333356 3.193335,7.526665 2.86,7.86 C2.526665,8.193335 2.1333356,8.36 1.68,8.36 C1.2266644,8.36 0.833335,8.193335 0.5,7.86 C0.166665,7.526665 0,7.1333356 0,6.68 C0,6.2266644 0.166665,5.833335 0.5,5.5 C0.833335,5.166665 1.2266644,5 1.68,5 Z M1.68,3.36 C1.2266644,3.36 0.833335,3.193335 0.5,2.86 C0.166665,2.526665 0,2.1333356 0,1.68 C0,1.2266644 0.166665,0.833335 0.5,0.5 C0.833335,0.166665 1.2266644,0 1.68,0 C2.1333356,0 2.526665,0.166665 2.86,0.5 C3.193335,0.833335 3.36,1.2266644 3.36,1.68 C3.36,2.1333356 3.193335,2.526665 2.86,2.86 C2.526665,3.193335 2.1333356,3.36 1.68,3.36 Z" />
            </svg>
        </a>
    );
}

function StreamingSupportIcon(props: { icon: Nullable<JSX.Element> }) {
    if (!props.icon) { return null; }

    return (
        <span className="ttip">
            {props.icon}
            <div>
                <p>Full streaming support:</p>
                <ul>
                    <li>Instantly browse a Filespace of any size.</li>
                    <li>Instantly access and browse snapshots of any size.</li>
                    <li>State of the art distributed file locking.</li>
                    <li>Optimized usage of local resources.</li>
                </ul>
            </div>
        </span>
    );
}

export { FilespaceCardTopRow };



// WEBPACK FOOTER //
// ./src/webportal/components/common/filespaceCardComponents/FilespaceCardTopRow.tsx